import { useEffect, useState } from 'react'

const CursorEffect = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [trail, setTrail] = useState([])

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY })
      
      // 添加轨迹点
      setTrail(prev => {
        const newTrail = [...prev, { x: e.clientX, y: e.clientY, id: `${Date.now()}-${Math.random()}` }]
        // 只保留最近的 10 个点
        return newTrail.slice(-10)
      })
    }

    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [])

  // 清理旧的轨迹点
  useEffect(() => {
    const interval = setInterval(() => {
      setTrail(prev => prev.slice(1))
    }, 50)
    return () => clearInterval(interval)
  }, [])

  return (
    <>
      {/* 鼠标光标 */}
      <div
        className="fixed w-5 h-5 border border-neon-cyan/50 rounded-full pointer-events-none z-[9999] mix-blend-screen"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          transform: 'translate(-50%, -50%)',
          transition: 'all 0.1s ease',
        }}
      >
        <div className="absolute inset-0 bg-neon-cyan/20 rounded-full animate-pulse"></div>
      </div>

      {/* 鼠标轨迹 */}
      {trail.map((point, index) => (
        <div
          key={point.id}
          className="fixed w-1 h-1 bg-neon-cyan rounded-full pointer-events-none z-[9998] mix-blend-screen"
          style={{
            left: `${point.x}px`,
            top: `${point.y}px`,
            transform: 'translate(-50%, -50%)',
            opacity: (index / trail.length) * 0.5,
          }}
        />
      ))}
    </>
  )
}

export default CursorEffect
